import { useIsMobile } from '@/hooks/use-mobile';
import { MobileInterstitial } from './MobileInterstitial';

interface DesktopOnlyGuardProps {
  children: React.ReactNode;
}

/**
 * Gates a route to desktop-only viewports. Mobile users see the
 * MobileInterstitial instead of the wrapped page. Used for /auth,
 * /subscribe, and onboarding flows so users never sign up or pay
 * on a device they can't actually use the product on.
 */
export function DesktopOnlyGuard({ children }: DesktopOnlyGuardProps) {
  const isMobile = useIsMobile();
  if (isMobile) return <MobileInterstitial />;
  return <>{children}</>;
}
